import { render } from "./kaDianStatistics.vue?vue&type=template&id=6516a021"
import script from "./kaDianStatistics.vue?vue&type=script&lang=js"
export * from "./kaDianStatistics.vue?vue&type=script&lang=js"

import "./kaDianStatistics.vue?vue&type=style&index=0&id=6516a021&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__